module.exports = __webpack_public_path__ + "img/NewSideBarandSideBar.ea4ae001.png";